<script>
    export default {
        name: "ZavtraPreloader",
        props: {
            show: Boolean,
            lgSize: Boolean,
            smSize: Boolean,
            isCatalog: Boolean,
            isColor: Boolean,
        },
    };
</script>

<template>
    <div
        class="global-preloader"
        :class="{
            'global-preloader--lg': lgSize,
            'global-preloader--md': smSize,
            'global-preloader--catalog': isCatalog,
            'global-preloader--color': isColor,
        }"
        v-show="show"
    >
        <svg
            class="global-preloader__wallet"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                class="global-preloader__card"
                d="M7.2 8.5c0-.6.5-1 1-1H18c.5 0 1 .4 1 1v4.8H7.2V8.5Z"
                fill="#C6D4FF"
            />
            <path
                d="M25.8 6.8H5c-.7 0-1.2.5-1.2 1.2v16.2c0 .7.5 1.2 1.2 1.2h21c.6 0 1-.5 1-1.2v-5.8h-8c-1.3 0-2.4-1-2.4-2.3 0-1.3 1-2.3 2.4-2.3h8V8c0-.7-.4-1.2-1-1.2Z"
            />
            <path d="M18.9 17.3a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z" />
        </svg>
    </div>
</template>

<style lang="scss">
    .global-preloader {
        @include center-absolute(0);
        z-index: 5;
        margin: auto;
        max-width: 100%;
    }

    .global-preloader__wallet {
        will-change: transform;
        animation: walletShake 3s cubic-bezier(0.36, 0.07, 0.19, 0.97) both infinite;
        path {
            &:not(:first-child) {
                fill: #fff;
            }
        }
    }

    .global-preloader__card {
        animation: walletCardTranslate 3s ease-in infinite;
    }

    .global-preloader--lg {
        @include box(60px);
    }

    .global-preloader--md {
        @include box(30px);
    }

    .global-preloader--color {
        .global-preloader__wallet path {
            &:not(:first-child) {
                fill: #2d5ae7;
            }
        }
    }

    .global-preloader--catalog {
        top: 186px;
        bottom: auto;
    }

    @keyframes walletCardTranslate {
        40% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-15%);
        }
        60% {
            transform: translateY(-15%);
        }
        70% {
            transform: translateY(0);
        }
    }

    @keyframes walletShake {
        5%,
        45% {
            transform: rotate(-2deg);
        }

        10%,
        40% {
            transform: rotate(4deg);
        }

        15%,
        25%,
        35% {
            transform: rotate(-6deg);
        }

        20%,
        30% {
            transform: rotate(6deg);
        }
    }
</style>
